<script>
  import { onDestroy } from "svelte";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../lib/mountFederatedSvelteComponent";
  import CustomersTable from "../components/customersTable.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";

  let el1;
  let customersCountInstance = null;

  const mountCustomersCount = async () => {
    const module = await import("App/alaceCustomers/count");
    const CustomersCount = module.default;

    if (el1) {
      customersCountInstance = mountFederatedSvelteComponent(customersCountInstance, CustomersCount, {
        target: el1,
      });
    }
  };

  void mountCustomersCount();

  onDestroy(() => {
    customersCountInstance = destroySvelteComponentInstance(customersCountInstance);
  });
</script>

<PageContainer>
  <div class="grid gap-3 w-full">
    <div class="uimodule" bind:this={el1} />
    <div class="uimodule">
      <CustomersTable />
    </div>
  </div>
</PageContainer>
